import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import api from "./api/install";
import { Dialog, ImagePreview } from "vant";
import "./utils/rem.js";
import HappyScroll from "vue-happy-scroll";
import "vue-happy-scroll/docs/happy-scroll.css";
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.use(HappyScroll);
Vue.use(Dialog, ImagePreview);
Vue.use(api);
// 系统错误捕获
const errorHandler = ({ error, errorFn }, vm) => {
  let errMsg = "系统出错啦";
  let canCloseDialog = false;
  if (error) {
    switch (error.code) {
      case 404:
      case 502:
        error.msg = "网络好像出现了点问题，请刷新页面再试";
        break;
      case 400:
      case 500:
        error.msg = "请求出错啦,请联系网站管理员";
        break;
      case "notstartquiz":
        error.msg = "测验没有学生提交,请点击确定返回主页";
        break;
      case "loginfailed":
        error.msg = "授课码无效";
        canCloseDialog = true;
        break;
      case "invalidrecord":
        error.msg = "找不到记录";
        break;
    }
  }
  console.error("抛出全局异常", error);
  Dialog.alert({
    title: `提示`,
    closeOnClickOverlay: canCloseDialog,
    message: error ? error.msg : "出错啦，请联系网站管理员"
    // message: errMsg
  })
    .then(() => {
      console.log("点击了关闭");
      if (error)
        if (errorFn) {
          // on close
          errorFn(error);
        }
    })
    .catch(() => {
      if (errorFn) {
        errorFn(error);
      }
    });
};
// Vue.config.errorHandler = errorHandler
Vue.prototype.$throw = error => errorHandler(error, this);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
